import PoiSub from "@/components/PoiSub/PoiSub";
export default {
  extends: PoiSub
};
